export default function handleAccordionBlocks() {
    let $elements = $('.js-accordion');
    $elements.each(function () {
        handleAccordion($(this));
    });
}

function handleAccordion($element) {
    $element.on("click", ".js-accordion-btn", function () {
        let $parent = $(this).parent(".js-accordion-item");
        $parent.toggleClass("accordion__item--active");
        $parent.find(".accordion__body").stop().slideToggle();
    });
}
